import { giphyRed } from '@giphy/js-brand'
import { SyntheticEvent, useState } from 'react'
import styled, { css } from 'styled-components'
import { BORDER_RADIUS_SMALL } from '../constants'

const Input = styled.input<{ invalid: boolean }>`
    background: #fff;
    border-radius: ${BORDER_RADIUS_SMALL}px;
    box-sizing: border-box;
    color: #000;
    font-size: 13px;
    font-weight: bold;
    height: 30px;
    line-height: 30px;
    padding: 0 10px;
    width: 100%;

    ${({ invalid }) =>
        invalid &&
        css`
            box-shadow: inset 0 0 0 2px ${giphyRed};
        `}
`

type Props = {
    className?: string
    defaultValue?: string
    onColorChange: (color: string) => void
}

const CreationToolsColorInput = ({ className, defaultValue, onColorChange }: Props) => {
    const [isInvalid, setIsInvalid] = useState<boolean>(false)

    const onInput = (e: SyntheticEvent<HTMLInputElement, MouseEvent>) => {
        const value = (e.currentTarget.value || '').replace(/#/g, '')

        if ((value.length === 3 || value.length === 6) && value.match(/^[0-9a-zA-Z]+$/)) {
            setIsInvalid(false)
            onColorChange(`#${value}`)
        } else {
            setIsInvalid(value.length > 1)
        }
    }

    return (
        <Input
            {...{
                className,
                type: 'text',
                placeholder: '#hex',
                defaultValue,
                invalid: isInvalid,
                onInput,
            }}
        />
    )
}

export default CreationToolsColorInput
